<template>
  <div class="image-batch-container">
    <div class="image-grid">
      <div
        v-for="(img, index) in currentImages"
        :key="index"
        class="image-item"
        :class="[
          selectId == img.id ? 'selected' : '',
          type == '产品图' ? 'productImg' : '',
        ]"
      >
        <img
          v-if="type == '产品图'"
          :src="img.url"
          :alt="img.alt"
          class="thumbnailImg"
        />
        <video
          v-if="type == '视频'"
          :src="img.url"
          class="thumbnail"
          muted
          autoplay
          :controls="true"
        ></video>
        <div class="actionBtn" v-if="type == '产品图'">
          <img
            src="https://image2.soole.com.cn/slb-picture2025102115062619168.jpg"
            @click="preview(img)"
            alt=""
          />
          <img
            src="https://image2.soole.com.cn/slb-picture2025102115063014599.jpg"
            @click="downLoad(img)"
            alt=""
          />
        </div>
        <div v-if="type != '视频'" class="mask"></div>

        <el-button class="select" type="primary" @click="handleSelect(img)"
          >选中设为{{ type }}</el-button
        >
        <el-button
          type="warning"
          v-if="type == '产品图'"
          class="tip_color"
          @click="editText(img)"
        >
          图片编辑
        </el-button>
        <el-button
          type="success"
          v-if="type == '产品图'"
          class="tip_template"
          @click="goGenerateAi(img)"
        >
          AI图生视频
        </el-button>
      </div>
    </div>
    <div class="batch-controls">
      <button
        @click="prevBatch"
        :disabled="currentBatch === 0"
        class="control-btn prev-btn"
      >
        <i class="fas fa-chevron-left"></i> 上一批
      </button>
      <span class="batch-indicator">
        第 {{ currentBatch + 1 }} 批 / 共 {{ totalBatches }} 批
      </span>
      <button
        @click="nextBatch"
        :disabled="currentBatch === totalBatches - 1"
        class="control-btn next-btn"
      >
        下一批 <i class="fas fa-chevron-right"></i>
      </button>
    </div>
    <aiDesignVue
      ref="aiDesignRef"
      @editHandlerChange="editHandler"
      :productId="formVal.productId"
      :productName="formVal.productName"
      :id="id"
      :imgUrl="imgUrl"
    ></aiDesignVue>
    <el-dialog title="图片预览" :visible.sync="dialogVisible" width="400px">
      <img :src="previewImgUrl" alt="" class="previewImg" />
    </el-dialog>
  </div>
</template>

<script>
import aiDesignVue from "./aiDesign.vue";
import { reqSetGoods } from "@/assets/api/aiProduct";
export default {
  components: {
    aiDesignVue,
  },
  props: {
    allImages: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: "",
    },
    formVal: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      batchSize: 4,
      currentBatch: 0,
      fullscreenImage: null,
      imgUrl: "",
      id: 0,
      selectId: 0,
      previewImgUrl: "",
      dialogVisible: false,
    };
  },
  computed: {
    // 图片切换
    totalBatches() {
      return Math.ceil(this.allImages.length / this.batchSize);
    },
    currentImages() {
      const start = this.currentBatch * this.batchSize;
      const end = start + this.batchSize;
      return this.allImages.slice(start, end);
    },
  },
  methods: {
    preview(img) {
      this.previewImgUrl = img.aiContent;
      this.dialogVisible = true;
    },
    async downLoad(img) {
      try {
        const response = await fetch(img.url);
        if (!response.ok) throw new Error("网络请求失败");

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `image_${new Date().valueOf()}.png`;
        document.body.appendChild(a);
        a.click();

        // 清理
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        this.$message.success("下载成功");
      } catch (error) {
        console.error("下载失败:", error);
        this.$message.error("下载失败，请重试");
      }
    },
    // 编辑器回调
    editHandler(data) {
      const index = this.allImages.findIndex(
        (item) => item.id.toString() == data.aiProductResultId
      );
      this.selectId = data.aiProductResultId;
      this.$set(this.allImages, index, {
        ...this.allImages[index],
        url: data.imageUrl,
      });
    },
    // 跳转生成视频
    goGenerateAi(img) {
      this.$router
        .push({
          path: "generateAi",
          query: {
            type: 3,
            text: this.formVal.text,
            productId: this.formVal.productId,
            productName: this.formVal.productName,
            imageUrl: img.url,
            imageToVideoQuick: true,
          },
        })
        .catch((res) => {});
      location.reload();
    },
    // 打开编辑图片
    editText(row) {
      this.imgurl = row.url;
      this.id = row.id;
      this.$refs.aiDesignRef.open(row.url);
    },
    // 选中设为图片
    async handleSelect(row) {
      console.log(row);

      const res = await reqSetGoods({
        aiProductResultId: row.id,
        aiText: row.aiContent,
      });
      if (res.code == 200) {
        this.$message.success(res.message);
      } else {
        this.$message.warning(res.message);
      }
    },
    // 上一批
    prevBatch() {
      if (this.currentBatch > 0) {
        this.currentBatch--;
      }
    },
    // 下一批
    nextBatch() {
      if (this.currentBatch < this.totalBatches - 1) {
        this.currentBatch++;
      }
    },
    showFullscreen(img) {
      this.fullscreenImage = img;
    },
  },
};
</script>

<style scoped lang="scss">
.previewImg {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
}

.image-batch-container {
  max-width: 2000px;
  margin: 0 auto;
  padding: 20px;
}
.batch-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  gap: 15px;
}
.control-btn {
  padding: 8px 16px;
  background-color: #4a6fa5;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}
.control-btn:hover:not(:disabled) {
  background-color: #3a5a8f;
}
.control-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
.batch-indicator {
  font-weight: bold;
  color: #333;
}
.image-grid {
  display: flex;
  margin-bottom: 30px;
}
.image-item {
  position: relative;
  width: 375px;
  height: 375px;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s;
  &.productImg {
    height: 407px;
  }
  .tip_template {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .tip_color {
    position: absolute;
    bottom: 0;
    right: 120px;
  }
  .actionBtn {
    position: absolute;
    display: none;
    z-index: 9;
    bottom: 60px;
    right: 16px;

    img {
      width: 20px;
      height: 20px;
      margin-right: 16px;
      cursor: pointer;
    }
  }
  .select {
    position: absolute;
    display: none;
    z-index: 9;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .mask {
    display: none;
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    top: 0%;
    background: rgba(0, 0, 0, 0.2);
  }
}
.image-item:hover .mask,
.image-item:hover .select {
  display: block;
}
.image-item:hover .actionBtn {
  display: flex;
}
.thumbnail {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
  cursor: pointer;
}
.thumbnailImg {
  width: 375px;
  height: 375px;
  object-fit: scale-down;
  cursor: pointer;
}
.image-caption {
  padding: 10px;
  text-align: center;
  background-color: #f8f9fa;
}
.fullscreen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.fullscreen-img {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
}
.selected {
  border: 4px solid #56a9ff;
}
</style>
